import { MapPin, TableSelectionEvent } from "@mcleod/components";
import { NoMap } from "@mcleod/components/src/components/map/NoMap";
import { TrimbleMap } from "@mcleod/components/src/components/map/TrimbleMap";
import { DateUtil, ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommLoginLogoutHistAndMapView } from "./autogen/AutogenLayoutMobileCommLoginLogoutHistAndMapView";

export class MobileCommLoginLogoutHistAndMapView extends AutogenLayoutMobileCommLoginLogoutHistAndMapView {
    private _pinMap = {};

    async onLoad() {
        this.addLayoutLoadListener(event => {
            const layout = this.layoutMobileCommLoginLogoutHistList;

            layout.addLayoutLoadListener(async event => {
                await this.layoutMobileCommLoginLogoutHistList.searchList();
            });

            layout.afterCrudClose = () => {
                if (layout.tableMobileCommLoginLogoutHist.selectedRow != null) {
                    this.loginLogoutMap.removeAllPins();
                    this.addPinAtLocation(layout.tableMobileCommLoginLogoutHist.selectedRow.data);
                }
            }

            layout.tableMobileCommLoginLogoutHist.addSelectionListener((event: TableSelectionEvent) => this.onSelectionChanged(event));
        });
    }

    private onSelectionChanged(event: TableSelectionEvent) {
        if (this.loginLogoutMap.map instanceof NoMap) {
            return;
        }

        const layout = this.layoutMobileCommLoginLogoutHistList;
        const modelRow = event.newRow?.data as ModelRow;

        if (modelRow != null) {
            const table = layout.tableMobileCommLoginLogoutHist;

            this.loginLogoutMap.removeAllPins();
            table.selectedRows.forEach(row => {
                this.addPinAtLocation(row.data);
            })
        }
    }

    private addPinAtLocation(modelRow: ModelRow) {
        if (this.loginLogoutMap.map instanceof NoMap) {
            return;
        }

        const loginLat = modelRow.get("login_position.latitude");
        const loginLon = modelRow.get("login_position.longitude");

        if (loginLat && loginLon) {
            const pin = new MapPin(loginLat, loginLon);
            pin.layoutName = null;
            pin.pinId = "login" + modelRow.get("id");
            pin.image = "pilot";
            pin.tooltip = this.buildTooltip("Login", modelRow.get("driver_full_name"), modelRow.get("tractor_id"),
                modelRow.get("login_date", ""), modelRow.get("logout_position.near_s_city"));
            pin.clusterable = false;

            this.loginLogoutMap.addPin(pin);
            this._pinMap[pin.pinId] = pin;
        }

        const logoutLat = modelRow.get("logout_position.latitude");
        const logoutLon = modelRow.get("logout_position.longitude");
        if (logoutLat && logoutLon) {
            const pin = new MapPin(logoutLat, logoutLon);
            pin.layoutName = null;
            pin.pinId = "logout" + modelRow.get("id");
            pin.image = "truck_blue";
            pin.tooltip = this.buildTooltip("Logout", modelRow.get("driver_full_name"), modelRow.get("tractor_id"),
                modelRow.get("logout_date", ""), modelRow.get("logout_position.near_s_city"));
            pin.clusterable = false;
            this.loginLogoutMap.addPin(pin);
            this._pinMap[pin.pinId] = pin;
        }

        // Fit pins and set zoom level once after adding all pins
        this.loginLogoutMap.fitPins();
        this.setZoomLevel();
    }

    private buildTooltip(status: string, driver: string, tractor: string, date: string, location: string): string {
        let tooltip = "";

        tooltip += "Event: " + status + "\n";
        tooltip += "Driver: " + driver + "\n";
        tooltip += "Tractor: " + tractor + "\n";
        if (date !== null && date !== "" && date !== undefined) {
            date = DateUtil.formatDate(new Date(date), "MM/dd/yyyy HH:mm:ss");
            tooltip += "Date/Time: " + date + "\n";
        }
        tooltip += "Near: " + location + "\n";

        return tooltip;
    }

    private setZoomLevel() {
        if (this.loginLogoutMap.map instanceof TrimbleMap) {
            this.loginLogoutMap.setZoom(3);
        }
    }
}
